var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#EEF3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.172 215.625C219.51 195.535 200.843 180.457 178.75 173.281C189.34 166.984 197.569 157.384 202.174 145.957C206.779 134.529 207.504 121.905 204.239 110.025C200.973 98.1455 193.898 87.6662 184.099 80.1975C174.301 72.7287 162.321 68.6836 150 68.6836C137.68 68.6836 125.7 72.7287 115.901 80.1975C106.103 87.6662 99.0273 98.1455 95.7619 110.025C92.4966 121.905 93.222 134.529 97.8267 145.957C102.431 157.384 110.661 166.984 121.25 173.281C99.1574 180.457 80.4905 195.535 68.8285 215.625C68.2559 216.567 67.9531 217.648 67.9531 218.75C67.9531 219.852 68.2559 220.933 68.8285 221.875C69.3627 222.833 70.1454 223.629 71.0942 224.179C72.043 224.729 73.1226 225.012 74.2191 225H225.782C226.878 225.012 227.958 224.729 228.907 224.179C229.855 223.629 230.638 222.833 231.172 221.875C231.745 220.933 232.048 219.852 232.048 218.75C232.048 217.648 231.745 216.567 231.172 215.625V215.625Z",
    fill: "#A4B4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.43db3c195a23218570a078125382c10c.svg";
export { ForwardRef as ReactComponent };